import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

export const initialState = {
  authedBrandPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  authedOrgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
